Preloader2.inlineTrigger = function(onComplete, delay){
    var index = this.inlineTriggers.length
    if(!Igloo.defined(delay)) delay = 10;

    this.inlineTriggers[index] = {onComplete:onComplete,delay:delay};
    return " onload=\"console.log('here-----');Preloader2.rit("+index+")\" ";
}

function GsapController({
    containerSelector,
    triggerStart = 'top bottom' ,
    triggerEnd = 'top top',
    items,
    toggleActions = "play play reverse reverse",
    showMarkers = false,
    scrub = .5,
	once = false,
	onScroll = true
}) {

    this.debug = false;

    // if (this.debug) console.log(`%c[GsapController]`, 'background:pink', `New instance`, containerSelector);

    this.containerSelector = containerSelector;
    this.triggerStart = triggerStart;
    this.triggerEnd = triggerEnd;
    this.scrub = scrub;
    this.items = items;
    this.toggleActions = toggleActions;
    this.showMarkers = showMarkers;
	this.once = once;
	this.onScroll = onScroll;

    this.container = document.querySelector(containerSelector);

    if (!this.items) {
        if (this.debug) console.log(`%c[GsapController]`, 'background:pink', `No items for ${containerSelector}`);
        return;  
    }

	// Disabled: iOS Safari toolbar show/hide triggers resize events,
	// which caused our resize handler to call ScrollTrigger.refresh()
	// during scroll and freeze/stutter scrolling.
    // this.resizeDelegate = jstage.addListener("resize", Igloo.delegate(this, this.onResize));
    this.onResize();

    this.animationLabel = `animation${Date.now()}`;
    
    gsap.registerPlugin(ScrollTrigger);
    this.timeline = gsap.timeline();

    this.calculateContainerBaseDimensions();

    this.animateItemsTimeline();

    this.createAnimation();

}

GsapController.prototype.calculateContainerBaseDimensions = function() {
    if (this.debug) console.log('%c[GsapController]', 'background: pink', 'calculateContainerBaseDimensions');
        
    if (this.container) {
        const newContainerBaseX = this.container.offsetWidth / 2 / 100;
        const newContainerBaseY = this.container.offsetHeight / 2 / 100;
        if (newContainerBaseX !== this.containerBaseX || newContainerBaseY != this.containerBaseY) {
            if (this.debug) console.log(this.container.offsetWidth, this.container.offsetHeight)
            this.containerBaseX = newContainerBaseX;
            this.containerBaseY = newContainerBaseY;
            this.setItemsInitialPosition();

			// Disabled: forcing ScrollTrigger.refresh() on resize caused
			// scroll interruptions on iPhone Safari when the browser toolbar resized.
            // ScrollTrigger.refresh();
            console.log("called!");
        }
    }
}

GsapController.prototype.setItemsInitialPosition = function() {
    // console.log('setItemsInitialPosition')
    this.items.forEach(({selector, start, props}) => {
        const $item = $(selector);
        if(typeof props !== 'undefined') {
            Object.keys(props).forEach((prop) => {
                const property = props[prop];
                // console.log([prop], (property.start));
                $item.get(0).style.setProperty([prop], (property.start));
            })
        } else {
            $item.css({transform: `translate(${this.containerBaseX * start.x}px, ${this.containerBaseY * start.y}px)`});
        }
    })
}

GsapController.prototype.createAnimation = function() {
	if (this.container) {

		if(!this.onScroll) {
			this.timeline.pause();
		}

		const settings = {
			trigger: this.containerSelector,
			markers: this.showMarkers,
			start: this.triggerStart,
			end: this.triggerEnd,
			scrub: this.scrub,
            toggleActions: this.toggleActions,
			invalidateOnRefresh: true
		}

		if(this.onScroll) {
			settings.animation = this.timeline;
		} else {
			settings.onEnter = () => this.timeline.play();
			if(!this.once) settings.onLeaveBack = () => this.timeline.reverse();
		}

		// this.timeline = gsap.timeline({paused: true});
		this.animation = ScrollTrigger.create(settings);
	}
}

GsapController.prototype.refresh = function() {
    this.calculateContainerBaseDimensions();
    ScrollTrigger.refresh();
}
GsapController.prototype.onResize = function() {
    this.refresh();
}

GsapController.prototype.animateItemsTimeline = function() {
    //console.log("E", e);
    if (this.container) {
        this.items.forEach(item => {
            this.animateItemTimeline(item);
        })
    }
}

GsapController.prototype.animateItemTimeline = function({
    selector,
    start = false,
    end = false,
    delay = 0,
    duration = 1,      // Uses the largest number and makes others relative to it (if using ScrollTrigger)
    ease = "sine.inOut", // Eases: https://greensock.com/docs/v3/Eases
	options = {},
    props = [],
	onEnter = () => {},
}) {
    const item = document.querySelector(selector);

    const from =  {};
    const to =  {
        duration,
        delay,
        ease
    };

    // Animate GSAP built in X and Y positions.
    if(start?.x !== false) from.x = () => this.containerBaseX * start.x;
    if(start?.y !== false) from.y = () => this.containerBaseY * start.y;

    if(end?.x !== false) to.x = () => this.containerBaseX * end.x;
    if(end?.y !== false) to.y = () => this.containerBaseY * end.y;

    // Animate CSS properties.
    if(props) {
        Object.keys(props).forEach((prop) => {
            if(props[prop]?.start !== false) from[prop] = props[prop].start;
            if(props[prop]?.end !== false)   to[prop] = props[prop].end;
        });
    }


    if (this.debug) {
        console.log(from,
            {
                ...to,
                ...options,
                onEnter,
            }
        );
    }

    this.timeline.fromTo(
        selector,
        from,
		{
			...to,
			...options,
			onEnter,
		},
        this.animationLabel
    );
}

GsapController.prototype.destroy = function() {
    if(this.resizeDelegate) jstage.removeListener("resize", this.resizeDelegate);
}


